import { render, staticRenderFns } from "./StockValueWidget.vue?vue&type=template&id=588b287a&"
import script from "./StockValueWidget.vue?vue&type=script&lang=js&"
export * from "./StockValueWidget.vue?vue&type=script&lang=js&"
import style0 from "./StockValueWidget.vue?vue&type=style&index=0&id=588b287a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports